import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { checkoutApi } from 'Utils/api';
import {
  fetchShippingZonesRequest,
  fetchShippingZonesSuccess,
  fetchShippingZonesFailure,
} from 'Redux/Slices/CheckoutSlice';

export const fetchShippingZonesEpic = (action$: any) =>
  action$.pipe(
    ofType(fetchShippingZonesRequest.type),
    mergeMap(() =>
      from(checkoutApi.getShippingZones()).pipe(
        map((response) => fetchShippingZonesSuccess(response.data.data)),
        catchError((error) =>
          of(fetchShippingZonesFailure(error.response?.data?.error || 'Failed to fetch shipping zones'))
        )
      )
    )
  );
